import {
  ByIdPayload,
  FailByIdPayload,
  OperationReducerTypes,
  PayloadAction,
  uniqueActionType
} from '@industi/ngx-common';

export const ArticleBrandDeleteActionTypes: OperationReducerTypes = {
  request: uniqueActionType('[article-brand] Delete'),
  requestFail: uniqueActionType('[article-brand] Delete fail'),
  requestSuccess: uniqueActionType('[article-brand] Delete success'),
  requestClearErrors: uniqueActionType('[article-brand] Delete clear errors'),
  requestClear: uniqueActionType('[article-brand] Delete clear')
};

export class ArticleBrandDeleteAction implements PayloadAction {
  readonly type = ArticleBrandDeleteActionTypes.request;

  constructor(public payload: ByIdPayload) {
  }
}

export class ArticleBrandDeleteFailAction implements PayloadAction {
  readonly type = ArticleBrandDeleteActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class ArticleBrandDeleteSuccessAction implements PayloadAction {
  readonly type = ArticleBrandDeleteActionTypes.requestSuccess;

  constructor(public payload: ByIdPayload) {
  }
}

export class ArticleBrandDeleteClearErrorsAction implements PayloadAction {
  readonly type = ArticleBrandDeleteActionTypes.requestClearErrors;

  constructor(public payload: ByIdPayload) {
  }
}

export class ArticleBrandDeleteClearAction implements PayloadAction {
  readonly type = ArticleBrandDeleteActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}
